import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { User } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, User>,
    'queryKey' | 'queryFn'
  >;
}

export const useAdminUserMeRequest = ({
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, User>(
    [Entities.Users, 'admin_user_me'],
    async () => {
      const { data } = await api.v1AdminUsersMeGet()
      return data
    },
    {
      ...options,
    },
  )
}
